import * as React from 'react';
import { styled } from '@mui/material/styles';
import {
  Container,
  Box,
  Typography,
  Stack,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  useTheme,
} from '@mui/material';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import DownloadIcon from '@mui/icons-material/Download';

// 🔹 Styled Table
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${TableCell.head}`]: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    fontWeight: 600,
  },
  [`&.${TableCell.body}`]: {
    fontSize: 14,
    color: theme.palette.text.primary,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

// 🔹 Datos de ejemplo
function createData(usuario, fecha, descripcion) {
  return { usuario, fecha, descripcion };
}

const acciones = [
  createData('eleal', "19 May, 2021 : 10:10 AM", "Registro al usuario jcastro"),
  createData('eleal', "18 May, 2021 : 3:12 PM", "Modifico al producto Silla por silla metalica"),
  createData('eleal', "17 May, 2021 : 2:15 PM", "Modifico la contraseña del usuario eleal"),
  createData('jtorres', "23 Abr, 2021 : 1:15 PM", "Registró al usuario eleal "),
];

const productos = [
  createData('eleal', "10 Jun, 2021 : 9:10 AM", "Agregó producto Mesa de madera"),
  createData('jtorres', "11 Jun, 2021 : 11:20 AM", "Actualizó stock de silla metálica"),
];

const usuarios = [
  createData('admin', "05 Jun, 2021 : 8:00 AM", "Creó usuario jcastro"),
  createData('admin', "06 Jun, 2021 : 10:30 AM", "Actualizó rol del usuario eleal"),
];

export default function Reportes() {
  const theme = useTheme();

  // 🔹 Función para renderizar tablas
  const renderTable = (title, data) => (
    <Box mb={5}>
      <Box mb={2} display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h6" fontWeight={600}>{title}</Typography>
        <Stack direction="row" spacing={1}>
          <Button variant="outlined" startIcon={<FilterAltIcon />} size="small">
            Filtrar
          </Button>
          <Button variant="contained" startIcon={<DownloadIcon />} size="small">
            Exportar
          </Button>
        </Stack>
      </Box>
      <TableContainer component={Paper} sx={{ borderRadius: 3, boxShadow: 3 }}>
        <Table>
          <TableHead>
            <TableRow>
              <StyledTableCell>Usuario</StyledTableCell>
              <StyledTableCell>Fecha</StyledTableCell>
              <StyledTableCell>Acción</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.length === 0 ? (
              <StyledTableRow>
                <StyledTableCell colSpan={3} align="center">No hay registros</StyledTableCell>
              </StyledTableRow>
            ) : (
              data.map((row, index) => (
                <StyledTableRow key={index}>
                  <StyledTableCell>{row.usuario}</StyledTableCell>
                  <StyledTableCell>{row.fecha}</StyledTableCell>
                  <StyledTableCell>{row.descripcion}</StyledTableCell>
                </StyledTableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Typography variant="h4" fontWeight={700} mb={3}>
        Reportes Generales
      </Typography>
      <Typography variant="body1" color="text.secondary" mb={5}>
        Revisa los registros, movimientos de productos y acciones de usuarios dentro de la plataforma.
      </Typography>

      {renderTable("Acciones del Sistema", acciones)}
      {renderTable("Movimientos de Productos", productos)}
      {renderTable("Usuarios", usuarios)}
    </Container>
  );
}